module.exports = __webpack_public_path__ + "img/GFP_Events_logo_portrait.5879ee5b.png";